import React from "react";
import Explanation from "./Explanation";
import {WithTranslation, withTranslation} from "react-i18next";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/05/2022
 * @last_update 16/05/2022
 **/
class SelectEquipmentExplanation extends React.Component<WithTranslation> {

    render() {

        return (

            <Explanation>
                {this.props.t("utils.alert.explanation.select-equipment")}
            </Explanation>

        );

    };

}

export default withTranslation()(SelectEquipmentExplanation);
